export const en = {
  entities: 'Entities',
  entities_table: 'Entities Table',
  total_entities: 'total entities',
  analyzed_entities: 'analyzed entities',
  un_analyzed_entities: 'un-analyzed entities',
  Top_5_trending_entities: 'top 5 trending entities',
  entities_group: 'entities/group',
  entities_category: 'entities / category',
  entities_platform: 'entities / platform',
  top_entities: 'top entities',
  entities_map: 'entities map',
  entities_category_modal: 'entities category',
  entities_categories: 'entities categories',
  num_entities: 'no. of entities',
  attach_entities: 'attach entities',
  search_entities: 'search entity',
  graduation_year: 'Graduation year',
  start_year:'Start year',
  analyzed_category_to_entities: 'analyzed category to entity',
  analyzed_group_to_entities: 'analyzed group to entity',
  merge_ent: 'Merge Entity',
  exist_ent: 'Existing Entity',
  new_ent: 'New Entity',
  select_ent: 'Please select the existing entity',
  select_new_ent: 'Please select the main entity to grab name & photo from',
  search_by_ent: 'search by entity',
  search_by_employee: 'search by employee name',
  add_new_entity: 'add new entity',
  edit_entity: 'edit entity',
  entity_name: 'entity name',
  established_data: 'Established On',
  entity_category: 'entity category',
  entity_group: 'entity group',
  added_successfully: 'Entity Added Successfully',
  unique_name: 'Entity name must be unique',
  edited_successfully: 'Entity Edited Successfully',
  entity_info: 'Entity Information',
  you_cant_preform:'You can’t perform this action at the moment, please contact the admin for further information',
  Add_another_contact_section: '+ Add another work section',
  are_you_sure_you_want_to_cancel_edit_entity:
    'Are you sure you want to cancel editing entity?',
  are_you_sure_you_want_to_cancel_edit_group:
    'Are you sure you want to cancel editing group?',
  are_you_sure_you_want_to_cancel_edit_category:
    'Are you sure you want to cancel editing category?',
  are_you_sure_you_want_to_cancel_add_entity:
    'Are you sure you want to cancel adding entity?',
  industry_type: 'Industry Type',
  entity_photos: 'Entity Photos',
  related_entity: 'Related Entities ',
  unanalyzed_entity_details: 'unanalyzed entity details',
  analyzed_entity_details: 'analyzed entity details',
  related_entities: 'Related Entities',
  similar_channel: 'Similar Channel ',
  entities_info: 'entity info',
  industries: 'industries',
  limit_5_industries: 'limit 5 industries',
  created_entity: 'Created Entity',
  related_sources: 'Related sources',
  Activities: 'Activities',
  activity_type: 'Activity Type',
  entity_sentiment_analysis: 'entity sentiment analysis',
  entity_details: 'entity details',
  entity: 'Entity',
  employee_on_linkedin: 'employee on linkedin',
  open_job: 'open jobs',
  jobs: 'Jobs',
  job_title: 'job title',
  job_status: 'status',
  post_on: 'post on',
  hiding_followers:'This entity is hiding the followers list',
  hiding_followings:'This entity is hiding the following list',
  employees: 'Employees',
  number_of_employees: 'Number of Employees',
  employees_grabbing_message:
    'Grabbing company employees is very costly and could cost 1000$, Please select the number of employees to grab.',
    employees_grabbing_small_message:'Grabbed employees may not all appear in the employees tab as some may be students, alumni, or ex-employees.',  
  ex_employees: 'EX-Employees',
  employee: 'employee',
  alumni: 'Alumni',
  students: 'Students',
  student: 'Student',
  Employee:'employee',
  search_by_alumni_name: 'search by Alumni name',
  search_by_student_name: 'search by Student name',
  start_date: 'start date',
  posted_on: 'posted on',
  student_name: 'student name',
  employee_name: 'employee name',
  alumni_name: 'alumni name',
  open: 'open',
  closed: 'closed',
  ex_employees: 'ex_employees',
  duration: 'duration',
  working_on_grabbing_entity_employees:
    'Working on grabbing ({{Entity_name}}) employees. you will be notified once finished',
};
export const ar = {
  duration: 'المدة',
  ex_employees: 'الموظفين السابقين',
  open: 'مفتوح',
  closed: 'مغلق',
  alumni_name: 'اسم الخريج',
  student_name: 'اسم الطالب',
  employee_name: 'اسم الموظف',
  posted_on: 'تم النشر في',
  start_date: 'تاريخ بدأ العمل',
  employee: 'الموظف',
  Employee:'موظف',
  employees: 'الموظفين',
  ex_employees: 'الموظفون السابقون',
  alumni: 'الخريجين',
  students: 'الطلاب',
  student: 'طالب',
  you_cant_preform:'لا يمكنك فعل هذا الطلب حاليا, يمكنك الرجوع لمسؤول الموقع لمعلومات اكثر',
  search_by_alumni_name: 'بحث بإسم الخريج',
  search_by_student_name: 'بحث بإسم الطالب',
  post_on: 'تاريخ النشر',
  job_status: 'حاله الوظيفه',
  job_title: 'المسمي الوظيفي',
  jobs: 'الوظائف',
  open_job: 'وظائف مفتوحة',
  employee_on_linkedin: 'موظف على لينكد إن',
  entity: 'كيان',
  entity_details: 'تفاصيل الكيان',
  entity_sentiment_analysis: 'تحليل نسب الاراء للكيان ',
  similar_channel: 'قناة مماثلة',
  created_entity: 'الكيان المنشأ',
  related_entities: 'الكيانات ذات صلة',
  unanalyzed_entity_details: ' تفاصيل الكيان الغير محلل',
  analyzed_entity_details: ' تفاصيل الكيان  المحلل',
  related_entity: 'كيانات ذات صلة',
  entity_photos: 'صور الكيان',
  industry_type: 'نوع الصناعه ',
  are_you_sure_you_want_to_cancel_edit_entity:
    'هل انت متأكد انك تريد الغاء تعديل  الكيان؟',
    employees_grabbing_small_message:'لن يظهر جميع الموظفين اللذين تم جلبهم فى صفحة الموظفين, حيث يمكن ان يكون بعضهم طلاب, او خريجيين, او موظفين سابقين.',
  are_you_sure_you_want_to_cancel_add_entity:
    'هل انت متأكد انك تريد الغاء إضافة الكيان؟',
  are_you_sure_you_want_to_cancel_edit_group:
    'هل انت متأكد انك تريد الغاء تعديل  المجموعة؟',
  are_you_sure_you_want_to_cancel_edit_catgory:
    'هل انت متأكد انك تريد الغاء تعديل  الفئة؟',
  Add_another_contact_section: '+ إضافة قسم تواصل آخر ',
  entity_info: 'معلومات الكيان',
  edited_successfully: 'تم تعديل الكيان بنجاح',
  added_successfully: 'تم إضافة الكيان بنجاح',
  unique_name: 'اسم الكيان مستخدم بالفعل.ادخل اسم جديد',
  entity_category: 'فئة الكيان',
  entity_group: 'مجموعة الكيان',
  established_data: 'تاريخ الإنشاء',
  entity_name: 'اسم الكيان',
  add_new_entity: 'إضافة كيان جديد',
  edit_entity: 'تعديل الكيان',
  search_by_ent: 'بحث بإسم الكيان',
  search_by_employee: 'بحث بإسم الموظف',
  select_ent: 'قم بإختيار الكيان الموجود بالفعل',
  select_new_ent: 'قم بإختيار الكيان الرئيسي لجلب الاسم والصوره منه',
  exist_ent: 'كيان موجود بالفعل',
  new_ent: 'كيان  جديد',
  merge_ent: 'ادمج الكيان',
  analyzed_category_to_entities: 'الكيانات المحللين في الفئة',
  analyzed_group_to_entities: 'الكيانات المحللين في المجموعة',
  entities: 'الكيانات',
  graduation_year: 'سنة التخرُج',
  start_year:'سنة الالتحاق',
  entities_table: 'جدول الكيانات',
  total_entities: 'إجمالي الكيانات',
  analyzed_entities: 'الكيانات المحللة',
  un_analyzed_entities: 'الكيانات غير المحللة',
  Top_5_trending_entities: 'أعلى 5 كيانات ترند',
  entities_group: 'كيانات / مجموعة',
  entities_category: 'كيانات / فئة',
  entities_platform: 'كيانات / منصة',
  top_entities: 'أعلى الكيانات',
  entities_map: 'خريطة الكيانات',
  entities_category_modal: 'فئة الكيانات',
  entities_categories: 'فئات الكيانات',
  num_entities: 'عدد الكيانات',
  hiding_followers:'هذا الكيان يخفي لائحة متابيعنه',
  hiding_followings:'هذا الكيان يخفي لائحة متابعهم',
  attach_entities: 'إضافة كيانات',
  search_entities: 'بحث بإسم الكيان',
  entities_info: 'بيانات الكيان',
  industries: 'الصناعات',
  limit_5_industries: 'لا يمكنك إضافة اكثر من 5 صناعات',
  related_sources: 'المصادر ذات الصلة',
  Activities: 'نشاطات',
  activity_type: 'نوع النشاط',
  number_of_employees: 'عدد الموظفين',
  employees_grabbing_message:
    'جلب موظفي الشركة يكلف كثيرًا ويمكن أن يكلف 1000 دولار، يرجى اختيار عدد الموظفين لجلبهم.',

  working_on_grabbing_entity_employees:
    'جاري العمل على جلب موظفي ({{Entity_name}}). سيتم إعلامك بمجرد الانتهاء',
};
